import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import {
  DigitalAssetsListConfigService,
  GungModalService,
  AuthService,
  DownloadService,
  DigitalAssetsService,
  MetadataService,
  DigitalAsset
} from 'gung-standard';
import { ColmecDigitalAssetsGridViewComponent } from '../components/colmec-digital-assets-grid-view/colmec-digital-assets-grid-view.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecDigitalAssetsListConfigService extends DigitalAssetsListConfigService {
  constructor(
    protected gungModalService: GungModalService,
    protected translateService: TranslateService,
    protected metadataService: MetadataService,
    protected authService: AuthService,
    protected downloadService: DownloadService,
    protected digitalAssetsService: DigitalAssetsService
  ) {
    super(gungModalService, translateService, metadataService, authService, downloadService, digitalAssetsService);
  }

  getLayouts(): ListLayout<DigitalAsset>[] {
    // if (this.isManagement) {
    //   return [{
    //     getIconClass: () => '',
    //     getListItemComponent: () => DigitalAssetsManagementGridViewComponent,
    //     getListLayoutComponent: () => ListLayoutMultipleComponent,
    //     getName: () => 'PimConceptGrid'
    //   }];
    // }
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ColmecDigitalAssetsGridViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'PimConceptGrid'
      }
    ];
  }
}
